export function ChittaraScrollBackground() {
  return (
    <div className="chittara-scroll-bg" aria-hidden="true">
      <div className="chittara-static-frame" />
      <div className="chittara-bg-softener" />
    </div>
  );
}
